export default "__VITE_ASSET__CfXE0S6q__"